function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#79C9FC",
  d: "M30 29a5 5 0 005-5c0-9.389-7.611-17-17-17S1 14.611 1 24s7.611 17 17 17c1.333 0 2.645-.153 3.915-.453-2.405-1.215-4.364-2.686-5.87-4.416-1.939-2.228-3.276-5.058-4.016-8.475A7 7 0 1125 24c.001 2.125 2.705 5 5.001 5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFC445",
  d: "M18 19a5 5 0 00-5 5c0 9.389 7.611 17 17 17s17-7.611 17-17S39.389 7 30 7c-1.333 0-2.645.153-3.915.453 2.405 1.215 4.51 2.569 5.87 4.416C33.937 14.563 37 20.813 37 24a7 7 0 01-14 0c-.023-2.344-2.704-5-5-5z"
}));

var SvgFlow = function SvgFlow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref);
};

export default SvgFlow;